import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FaPlus, FaStore, FaSearch } from 'react-icons/fa'
import { getAllMerchants } from '../../../store/actions/merchants'
import { Button } from '../../../UI'
import MerchantForm from './MerchantForm'
import MerchantListItem from './MerchantListItem'
import MerchantDetails from './MerchantDetails'
import Container from './styles'

const Merchants = () => {
  const dispatch = useDispatch()
  const merchantData = useSelector((s) => s.MerchantData || { data: [] })
  const merchants = merchantData.data || []
  const [showForm, setShowForm] = useState(false)
  const [showDetails, setShowDetails] = useState(false)
  const [selectedMerchant, setSelectedMerchant] = useState(null)
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    dispatch(getAllMerchants())
  }, [dispatch])

  const handleSearch = (e) => {
    const value = e.target.value
    setSearchTerm(value)
    dispatch(getAllMerchants(1, 10, value))
  }

  const handleMerchantClick = (merchant) => {
    setSelectedMerchant(merchant)
    setShowDetails(true)
  }

  const openForm = () => {
    setShowForm(true)
  }

  return (
    <Container>
      <header>
        <div className="top--row">
          <h2>Merchants Management</h2>
          <p className="subtitle">Create and manage your merchant accounts</p>
        </div>
        <div className="header--row">
          <div className="search-container">
            <FaSearch className="search-icon" />
            <input 
              type="search" 
              placeholder="Search merchants..." 
              className="search-input"
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>
          <Button className="add--btn" onClick={openForm}>
            <FaPlus className="icon" />
            <span>Add Merchant</span>
          </Button>
        </div>
      </header>

      <div className="content--container">
        {merchants.length === 0 ? (
          <div className="empty--container">
            <FaStore style={{ fontSize: '4rem', color: 'rgba(255, 255, 255, 0.3)' }} />
            <h3>No Merchants Yet</h3>
            <p className="instruction">
              Create merchant accounts to manage sub-businesses under your company
            </p>
            <Button className="add--btn" onClick={openForm}>
              <FaPlus className="icon" />
              Add First Merchant
            </Button>
          </div>
        ) : (
          <div className="merchants--grid">
            {merchants.map((merchant) => (
              <div key={merchant.id} onClick={() => handleMerchantClick(merchant)}>
                <MerchantListItem merchant={merchant} />
              </div>
            ))}
          </div>
        )}
      </div>

      {showForm && (
        <MerchantForm 
          show={showForm} 
          handleClose={() => setShowForm(false)} 
        />
      )}
      
      {showDetails && (
        <MerchantDetails 
          show={showDetails} 
          handleClose={() => {
            setShowDetails(false)
            setSelectedMerchant(null)
          }} 
          merchant={selectedMerchant} 
        />
      )}
    </Container>
  )
}

export default Merchants
